import { render, staticRenderFns } from "./ThemePropSide.vue?vue&type=template&id=bad88b94&scoped=true"
import script from "./ThemePropSide.vue?vue&type=script&lang=js"
export * from "./ThemePropSide.vue?vue&type=script&lang=js"
import style0 from "./ThemePropSide.vue?vue&type=style&index=0&id=bad88b94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad88b94",
  null
  
)

export default component.exports